import PropTypes from 'prop-types';

const contentVersionPropType = PropTypes.shape({
    uuid: PropTypes.string,
    label: PropTypes.string,
    content: PropTypes.string,
    updatedByUser: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    }),
    updatedOn: PropTypes.string,
});

export default contentVersionPropType;
